import { service as request } from '@/config/axios/service'
import type { LoginParams, LoginResponse, UserInfo } from '@/types/user'

// 发送登录验证码
export const sendLoginCode = (mobile: string) => {
  return request<boolean>({
    url: '/api/v1/member/auth/send-sms-code',
    method: 'post',
    data: {
      mobile,
      scene: 1, // 1=登录
    },
    isAuth: false, // 不需要认证
  })
}

// 验证码登录
export const smsLogin = (data: { mobile: string; code: string }) => {
  return request<LoginResponse>({
    url: '/api/v1/member/auth/sms-login',
    method: 'post',
    data,
    isAuth: false, // 不需要认证
  })
}

// 密码登录
export const passwordLogin = (data: { mobile: string; password: string }) => {
  return request<LoginResponse>({
    url: '/api/v1/member/auth/login',
    method: 'post',
    data,
    isAuth: false, // 不需要认证
  })
}

// 登录（统一接口）
export const login = (data: LoginParams) => {
  // 根据type调用不同的登录接口
  if (data.type === 'sms_code' && data.code) {
    return smsLogin({ mobile: data.mobile, code: data.code })
  } else if (data.type === 'password' && data.password) {
    return passwordLogin({ mobile: data.mobile, password: data.password })
  }
  
  // 默认使用密码登录
  return request<LoginResponse>({
    url: '/api/v1/member/auth/login',
    method: 'post',
    data,
    isAuth: false,
  })
}

// 退出登录
export const logout = () => {
  return request({
    url: '/api/v1/member/auth/logout',
    method: 'post',
  })
}

// 获取用户信息
export const getUserInfo = () => {
  return request<UserInfo>({
    url: '/api/v1/member/user/get',
    method: 'get',
  })
}

// 更新用户信息
export const updateUserInfo = (data: Partial<UserInfo>) => {
  return request({
    url: '/api/v1/member/user/update',
    method: 'put',
    data,
  })
}

// 发送修改密码验证码
export const sendUpdatePasswordCode = (mobile: string) => {
  return request<boolean>({
    url: '/api/v1/member/auth/send-sms-code',
    method: 'post',
    data: {
      mobile,
      scene: 3, // 3=修改密码 (MEMBER_UPDATE_PASSWORD)
    },
  })
}

// 修改用户密码
export const updateUserPassword = (data: { password: string; code: string }) => {
  return request<boolean>({
    url: '/api/v1/member/user/update-password',
    method: 'put',
    data,
  })
}

// 发送修改手机号验证码
export const sendUpdateMobileCode = (mobile: string) => {
  return request<boolean>({
    url: '/api/v1/member/auth/send-sms-code',
    method: 'post',
    data: {
      mobile,
      scene: 2, // 2=修改手机号 (MEMBER_UPDATE_MOBILE)
    },
  })
}

// 校验短信验证码（仅验证，不消费）
export const validateSmsCode = (data: { mobile: string; code: string; scene: number }) => {
  return request<boolean>({
    url: '/api/v1/member/auth/validate-sms-code',
    method: 'post',
    data,
  })
}

// 修改手机号
export const updateMobile = (data: { mobile: string; code: string; oldCode: string }) => {
  return request<boolean>({
    url: '/api/v1/member/user/update-mobile',
    method: 'put',
    data,
  })
}

// 发送重置密码验证码（忘记密码时使用）
export const sendResetPasswordCode = (mobile: string) => {
  return request<boolean>({
    url: '/api/v1/member/auth/send-sms-code',
    method: 'post',
    data: {
      mobile,
      scene: 4, // 4=重置密码 (MEMBER_RESET_PASSWORD)
    },
    isAuth: false,
  })
}

// 重置用户密码（忘记密码时使用）
export const resetUserPassword = (data: { mobile: string; password: string; code: string }) => {
  return request<boolean>({
    url: '/api/v1/member/user/reset-password',
    method: 'put',
    data,
    isAuth: false,
  })
}
